import { ComponentProps, useContext } from 'react';

import Button from '../Button/Button';
import { FormContext } from '../Form/FormContext';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

type SubmitButtonProps = { loading?: boolean } & ComponentProps<typeof Button>;

const SubmitButton = ({
    children,
    loading = false,
    disabled,
    type = 'submit',
    ...buttonProps
}: SubmitButtonProps) => {
    const { submitting, disabled: formDisabled } = useContext(FormContext);
    const submittingOrLoading = submitting || loading;

    const content = submittingOrLoading ? (
        <LoadingSpinner color="disabled" />
    ) : (
        children
    );

    return (
        <Button
            {...buttonProps}
            type={type}
            disabled={submittingOrLoading || disabled || formDisabled}
        >
            {content}
        </Button>
    );
};

export default SubmitButton;
